import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'books-list',
  templateUrl: 'bookslist.html'
})

export class BooksList{
	
	listTitle:string="";
	listType:string="";
	booksList:any[];
	constructor(public global: AppState,public params: NavParams) {
    this.listTitle = params.data.listTitle;
    this.listType = params.data.type;
    this.booksList = params.data.list;
	} 
	loadMore(refresher){
		setTimeout(() => {
      console.log("这里加载新数据");
      refresher.complete();
    }, 1000);
	}
	
}


// WEBPACK FOOTER //
// ./src/pages/application/life/books/bookslist/bookslist.ts